import React, {
    createContext,
    FC,
    ReactNode,
    useContext,
    useMemo,
} from 'react';

// classes
import FeatureFlagsHelper from '../classes/FeatureFlagsHelper';

// hooks
import useGetFeatureFlagConfig from '../hooks/customer/useGetFeatureFlagConfig';

interface FeatureFlagsProviderProps {
    children: ReactNode;
}

const FeatureFlagsContext = createContext<FeatureFlagsHelper | undefined>(
    undefined,
);

export const FeatureFlagsProvider: FC<FeatureFlagsProviderProps> = ({
    children,
}) => {
    const { data } = useGetFeatureFlagConfig();

    const featureFlagHelper = useMemo<FeatureFlagsHelper | undefined>(() => {
        if (data) {
            FeatureFlagsHelper.init(data);
            return FeatureFlagsHelper.getInstance();
        }
        return undefined;
    }, [data]);

    return (
        <FeatureFlagsContext.Provider value={featureFlagHelper}>
            {children}
        </FeatureFlagsContext.Provider>
    );
};

export const useFeatureFlags = (): FeatureFlagsHelper | undefined => {
    return useContext(FeatureFlagsContext);
};
